import mixpanel from 'mixpanel-browser';
import logger from './logger';
import { isDevelopment } from './util';

let initialized = false;

export const initMixpanel = () => {
    if (!initialized) {
        if (typeof window !== 'undefined') {
            // Near entry of your product, init Mixpanel
            window.mixpanel = mixpanel;
            window.mixpanel.init("0da1349d52b241dfaceb56c8e85cd197", {
                debug: true,
                track_pageview: true,
                persistence: "localStorage",
                ignore_dnt: true,
            });
            logger.info('mixpanel init');
            initialized = true;
        }
    }
};

export const trackEvent = (event: string, properties?: Record<string, unknown>) => {
    if (isDevelopment()) {
        logger.info('is development, mixpanel track', event, properties);
        return;
    }
    if (!initialized) {
        initMixpanel();
    }
    if (typeof window !== 'undefined' && window.mixpanel !== undefined) {
        window.mixpanel.track(event, properties);
        logger.info('mixpanel track', event, properties);
    }
};